import { useNavigate, Routes, Route, useSearchParams } from "react-router";
import { useEffect, useState, useRef, createContext } from "react";
import { Alert } from "antd";
import Dashboard from "./Dashboard";
import CallsReport from "./pages/reports/CallsReport";
import AuthContainerPage from "./pages/auth/AuthContainerPage";
import LoginWrapper from "./components/auth/LoginWrapper";
import ProtectedRoute from "./components/routing/ProtectedRoute";
import PublicRoute from "./components/routing/PublicRoute";
import RoleBasedRedirect from "./components/routing/RoleBasedRedirect";
import Unauthorized from "./pages/Unauthorized";
import * as Sentry from "@sentry/react";

if (import.meta.env.VITE_ENV_MODE != "DEV") {
  Sentry.init({
    dsn: "https://3875937586deacd9f66bc7eab2c241bb@o4508013519634432.ingest.de.sentry.io/4509332145963088",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    enableLogs: true,
  });
}

export const GlobalContext = createContext();
function App() {
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("success");
  const timerRef = useRef(null);
  const [languages, setLanguages] = useState([]);

  // Handle toast visibility and auto-dismissal
  useEffect(() => {
    if (toastOpen) {
      // Clear any existing timers
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      // Set timer to hide the alert after 3 seconds
      timerRef.current = setTimeout(() => {
        setToastOpen(false);
      }, 5000);
    }

    // Cleanup timer on component unmount or when toast state changes
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [toastOpen]);

  return (
    <GlobalContext.Provider
      value={{
        setToastOpen: setToastOpen,
        setToastMessage: setToastMessage,
        setToastSeverity: setToastSeverity,
        languages: languages,
      }}
    >
      <div className="fixed z-50 bottom-4 left-1/2 transform -translate-x-1/2 transition-all duration-300 ease-in-out pointer-events-none">
        <Alert
          className={`shadow-lg ${
            toastOpen ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"
          }`}
          message={toastMessage}
          type={toastSeverity}
          showIcon
        />
      </div>
      <Routes>
        {/* Public routes */}

        <Route
          path="/login"
          element={
            <PublicRoute>
              <AuthContainerPage>
                <LoginWrapper />
              </AuthContainerPage>
            </PublicRoute>
          }
        />

        <Route path="/unauthorized" element={<Unauthorized />} />

        {/* Root redirect based on role */}
        {/* <Route path="/" element={<RoleBasedRedirect />} /> */}

        {/* Customer routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute allowedRoles={["customer"]}>
              <Dashboard>
                <CallsReport />
              </Dashboard>
            </ProtectedRoute>
          }
        />
      </Routes>
    </GlobalContext.Provider>
  );
}

export default App;
